import React from 'react';
import './App.css';
import EducationSection from './components/EducationSection';
import ExperienceSection from './components/ExperienceSection';
import ProfileHeader from './components/ProfileHeader';
import SkillsSection from './components/SkillsSection';
import cvData from './data.json';

function App() {
  const { aboutMe, experience, knowledge } = cvData;

  return (
    <div className="cv-container">
      {/* Header / Perfil Principal */}
      <ProfileHeader 
        profile={aboutMe.profile} 
        relevantLinks={aboutMe.relevantLinks} 
      />

      <main className="cv-main">
        {/* Descripción */}
        {/* <section className="cv-section two-column-section">
          <div className="section-header">
            <h3 className="section-title">Sobre mí</h3>
          </div>
          <div className="section-content">
            <div className="description">
              {aboutMe.profile.description.split('\n\n').map((paragraph: string, index: number) => (
                <p key={index}>{paragraph}</p>
              ))}
            </div>
          </div>
        </section> */}

        {/* Stack Principal */}
        {(cvData as any).manfredSpecificData && (
          <section className="cv-section two-column-section">
            <div className="section-header">
              <h3 className="section-title">Stack Principal</h3>
            </div>
            <div className="section-content">
              <div className="main-stack">
                {(cvData as any).manfredSpecificData.mainStackTechs.map((tech: any, index: number) => (
                  <span key={index} className="main-tech-tag">
                    {tech.name}
                  </span>
                ))}
              </div>
            </div>
          </section>
        )}

        {/* Educación */}
        <section className="cv-section two-column-section">
          <div className="section-header">
            <h3 className="section-title">Educación</h3>
          </div>
          <div className="section-content">
            <EducationSection studies={knowledge.studies} />
          </div>
        </section>

        {/* Experiencia Laboral */}
        <section className="cv-section two-column-section">
          <div className="section-header">
            <h3 className="section-title">Experiencia Laboral</h3>
          </div>
          <div className="section-content">
            <ExperienceSection jobs={experience.jobs} />
          </div>
        </section>

        {/* Habilidades Técnicas */}
        <section className="cv-section two-column-section">
          <div className="section-header">
            <h3 className="section-title">He trabajado con...</h3>
          </div>
          <div className="section-content">
            <SkillsSection hardSkills={knowledge.hardSkills} />
          </div>
        </section>

        {/* Idiomas */}
        <section className="cv-section two-column-section">
          <div className="section-header">
            <h3 className="section-title">Idiomas</h3>
          </div>
          <div className="section-content">
            <div className="languages-list">
              {knowledge.languages.map((language: any, index: number) => (
                <div key={index} className="language-item">
                  <span className="language-name">{language.fullName}</span>
                  <span className="language-level">{language.level}</span>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Datos Curiosos */}
                {/* Sección oculta: Datos curiosos */}
        {/* 
        {data.aboutMe.interestingFacts && data.aboutMe.interestingFacts.length > 0 && (
          <div className="two-column-section">
            <div className="section-header">
              <h2 className="section-title">Datos Curiosos</h2>
            </div>
            <div className="section-content">
              <div className="facts-list">
                {data.aboutMe.interestingFacts.map((fact: any, index: number) => (
                  <div key={index} className="fact-item">
                    <h4 className="fact-topic">{fact.topic}</h4>
                    <p className="fact-text">{fact.fact}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}
        */}
      </main>
    </div>
  );
}

export default App;
